// import { useSelector } from "react-redux";
// import { useNavigate , useParams} from "react-router-dom";

// export function ProtectedRoute({ element, ...rest }) {
//   const isAuthenticated = useSelector((state) => state.isAuthenticated);
//   const user = useSelector((state) => state?.user);
//   const { a } = useParams();
//   const navigate = useNavigate(); 
//   const { lang } = useParams(); 

//   if (!user) {
//     return navigate(`/${lang}/`);
//   }
//   return <>{element}</>;
// }

import { useSelector } from "react-redux";
import { Navigate, useParams } from "react-router-dom";
import { isOtpVerified } from "../../utils/otpSession";
import { loginPath, resolveLang } from "../../utils/navigation";

export function ProtectedRoute({ element, requireOtp = false }) {
  const user = useSelector((state) => state?.user);
  const isAuthenticated = useSelector((state) => state?.isAuthenticated);
  const { lang } = useParams();
  const resolvedLang = resolveLang(lang);

  if (!user && !isAuthenticated) {
    return <Navigate to={loginPath(resolvedLang)} replace />;
  }

  if (requireOtp && !isOtpVerified()) {
    return <Navigate to={`/${resolvedLang}/home`} replace />;
  }

  return element;
}

